/* istanbul ignore file */
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

// This order should match the html template tabs order
export const VALID_TABS = ['toc', 'toolsAndProps', 'workflow', 'preferences', 'properties'] as const;

export type TabId = (typeof VALID_TABS)[number];

/**
 * Tabs viewer helper service
 * Enables to modify some behaviour of the tab viewer
 */
@Injectable({ providedIn: 'root' })
export class TabsViewerHelperService {
    private setCurrentTabSubject$ = new Subject<TabId>();
    private setCurrentTab$ = this.setCurrentTabSubject$.asObservable();

    private setWorkflowTabStatusSubject$ = new Subject<'enabled' | 'disabled'>();
    private setWorkflowTabStatus$ = this.setWorkflowTabStatusSubject$.asObservable();

    /**
     * Sets the current tab to show
     */
    setCurrentTab(tabId: TabId): void {
        this.setCurrentTabSubject$.next(tabId);
    }

    /**
     * Returns an observable to know when a request to change the current tab has been done
     */
    onSetCurrentTab(): Observable<TabId> {
        return this.setCurrentTab$;
    }

    /**
     * Sends message to enable workflow tab
     */
    enableWorkflowTab(): void {
        this.setWorkflowTabStatusSubject$.next('enabled');
    }

    /**
     * Sends message to disable workflow tab
     */
    disableWorkflowTab(): void {
        this.setWorkflowTabStatusSubject$.next('disabled');
    }

    /**
     * Returns observable listening to workflow tab estatus message
     */
    onWorkflowTabStatus(): Observable<'enabled' | 'disabled'> {
        return this.setWorkflowTabStatus$;
    }
}
